export const SNAPCHAT_PIXEL_ID = '6ce2fe3e-5197-4d61-b5d9-79f16fbd97b9';
export const SNAPCHAT_PIXEL_VIEW = 'PAGE_VIEW';
export const SNAPCHAT_PIXEL_TRACK = 'track';
export const SNAPCHAT_PIXEL_EVENT_PURCHASE = 'PURCHASE';
export const SNAPCHAT_PIXEL_EVENT_ADD_CART = 'ADD_CART';
export const SNAPCHAT_PIXEL_EVENT_SIGN_UP = 'SIGN_UP';
